import { __decorate, __metadata } from "tslib";
import { Inject, Injectable } from '@angular/core';
import { AppEnvironment } from '@ho/shared/data-access/core/app-environment.model';
import { SessionQuery } from './session.query';
import { TranslateService } from '@ngx-translate/core';
export var UserType;
(function (UserType) {
    UserType[UserType["Admin"] = 0] = "Admin";
    UserType[UserType["Manager"] = 1] = "Manager";
    UserType[UserType["Affiliate"] = 2] = "Affiliate";
})(UserType || (UserType = {}));
export const UserTypeSystemMap = new Map([
    [UserType.Admin, 'admin'],
    [UserType.Manager, 'manager'],
    [UserType.Affiliate, 'affiliate'],
]);
export const UserTypeMap = new Map([
    [UserType.Admin, 'Global.UserRole.Admin'],
    [UserType.Manager, 'Global.UserRole.Manager'],
    [UserType.Affiliate, 'Global.UserRole.Affiliate'],
]);
let SessionUserTypeService = class SessionUserTypeService {
    constructor(environment, _sessionQuery, _translate) {
        this.environment = environment;
        this._sessionQuery = _sessionQuery;
        this._translate = _translate;
        this.userRole = UserType;
        this._data = UserTypeMap;
    }
    list() {
        return this._data;
    }
    get(status) {
        const s = this._data.get(status);
        return s ? this._translate.instant(s) : s;
    }
    isAdmin() {
        return this.environment.role.includes(UserType.Admin);
    }
    isAffiliate() {
        return this.environment.role.includes(UserType.Affiliate);
    }
    isManager() {
        return this.environment.role.includes(UserType.Manager);
    }
    isAdminRole() {
        return this._sessionQuery.userInfo().user_type === this.userRole.Admin;
    }
    isAffiliateRole() {
        return this._sessionQuery.userInfo().user_type === this.userRole.Affiliate;
    }
    isManagerRole() {
        return this._sessionQuery.userInfo().user_type === this.userRole.Manager;
    }
    getAPIUserRoleUrl() {
        const userInfo = this._sessionQuery.userInfo();
        const userType = userInfo ? userInfo.user_type : null;
        return UserTypeSystemMap.get(userType);
    }
};
SessionUserTypeService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [AppEnvironment,] }] },
    { type: SessionQuery },
    { type: TranslateService }
];
SessionUserTypeService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [Object, SessionQuery,
        TranslateService])
], SessionUserTypeService);
export { SessionUserTypeService };
